import React, { Component } from "react";
import "../css/Home.css";

export default class Home extends Component {
  render() {
    return (
      <div className="Home">
        <div className="lander">
          <h1>SAWBO</h1>
          <p>The Sawbo app</p>
        </div>
      </div>
    );
  } 
}